import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from './utils/axios';
import { useAuth } from './hooks/use-auth';

export const VisitLogger = () => {
    const location = useLocation();
    const { user } = useAuth();
    useEffect(() => {
        // location.search is the ?query string
        // location.pathname is the path without the query string
        const logRouteChange = async () => {
            try {
                await axios.post('/api/logFront', {
                    route: JSON.stringify({
                        originalUrl: location.pathname + (location.search || ''),
                        method: 'GET',
                    }),
                    user: JSON.stringify({
                        uid: user?.nni || user?.email || 'anonymous',
                        accessToken: user?.accessToken || null,
                        roleToken: user?.roles || [],
                    }),
                    value: JSON.stringify({ pathname: location.pathname, search: location.search }),
                    ip: 'client-side', // IP will be set server-side
                    category: 'front',
                });
            } catch (error) {
                console.error('Error logging route change:', error);
            }
        };
        logRouteChange();
    },
        [location.pathname, location.search, user] // Trigger on route or user change
    );

    return null; // No UI, just logic
};